module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABEklEQVRIx63UIUsEURAA4GU5DAaDmAwGMcklgxyX/REGkxj9DcIF8/0EwwURERHT2Qwmk5hMchgUTCaRY79nMSyPt5zsvonDMh8zb2eKoiGwjjHOityBI3yHEAIq9HMWH6IKtcBVTuAyRIGAnVzAe0gEbnMBVQMQMMgB/ISGwHUOYJYo/IURVnMA0wSw37Zemcg9JHIfOYG7RG6782hqIyrxFo1omg34Q04joMJmTmAD8wjJe/QwSXQxzAlsxUuHV6xF3y13QcaJnXjGLga4wRPKtsBK/Ec1nJDWi1hgr+kA1oAX9Logo390cdgFKHG+AJhhqQvSw8UC5Lg1UOvkJF7CGnDfCahBfUzwiTkecZB66F/N9YQ7A1KmxwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.png
// module id = JhOT
// module chunks = 0